import React from "react";
import { Button, Space } from "antd";

const ActionButtons = ({
  onGetQuote,
  onLearnMore,
  getQuoteText = "Get Quote",
  learnMoreText = "Learn More",
  primaryColor = "#009EFF",
  borderColor = "#d9d9d9",
  learnMoreVariant = "black", // "black" or "white"
  style
}) => {
  const learnMoreClass =
    learnMoreVariant === "white"
      ? "learn-more-button-white"
      : "learn-more-button-black";

  const learnMoreBtnClass =
    learnMoreVariant === "white" ? "button-text-white" : "button-text";

  return (
    <div className="buttons-container" style={style}>
      <Button
        type="primary"
        className="get-quote-button"
        onClick={onGetQuote}
        style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
      >
        <span className="button-text">{getQuoteText}</span>
      </Button>

      <Button
        type="default"
        className={learnMoreClass}
        onClick={onLearnMore}
        style={{ borderColor: borderColor }}
      >
        <span className={learnMoreBtnClass}>{learnMoreText}</span>
      </Button>
    </div>
  );
};

export default ActionButtons;
